module.exports = __webpack_public_path__ + "static/media/hamburgerBlack.67b2e191.svg";